import ChangeEmailValidation from './ChangeEmailValidation.container';

export default ChangeEmailValidation;
